<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-demo__news">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.title" placeholder="请输入任务名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                @sort-change="dataListSortChangeHandle" style="width: 100%">
                <!--                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="id" label="残协编号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="organization" label="残协名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="organization" label="机构地址" header-align="center" align="center"></el-table-column>
                
                <!-- <el-table-column prop="organization" label="发布任务机构" header-align="center" align="center"></el-table-column> -->
                <el-table-column prop="creator" label="专职委员" header-align="center" align="center"></el-table-column>
                <!-- <el-table-column prop="createDate" label="发布时间" header-align="center" align="center"></el-table-column> -->
                <el-table-column prop="taskName" label="任务名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="taskType" label="任务类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType== '1'">就业调查</span>
                        <span v-if="scope.row.taskType== '2'">走访入户</span>
                        <span v-if="scope.row.taskType== '3'">文体活动</span>
                    </template>
                </el-table-column>
                <el-table-column prop="progress" label="完成情况" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                            @click="goJumpQuery(`statistics`, { id: scope.row.id  ,taskType:scope.row.taskType})">任务统计</el-button>
                        <el-button type="text" size="small"
                            @click="goJumpQuery(`conditionList`, { id: scope.row.id  ,taskType:scope.row.taskType})">任务结果</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
    mixins: [mixinViewModule],
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/task/taskResultList",
                getDataListIsPage: true,
                deleteURL: "/demo/news",
                deleteIsBatch: true,
                createdIsNeed: true,
            },
            daterange: null,
            dataForm: {
                title: "",
                startDate: "",
                endDate: "",
                area: JSON.parse(localStorage.getItem('org')).area || ''
            },
            OpenViewAssociation: false,
        };
    },
    watch: {
        daterange(val) {
            if (val == null) {
                this.dataForm.startDate = null;
                this.dataForm.endDate = null;
            } else {
                this.dataForm.startDate = val[0];
                this.dataForm.endDate = val[1];
            }
        },
    },
    methods: {
        
    },
};
</script>
